import { ThunkCreator } from 'easy-peasy';
import { DependencyList } from 'react';
import { useAsyncEffect } from './useAsyncEffect';

export const useThunk = (thunkCreator: ThunkCreator<void, void>, deps?: DependencyList) => {
    useAsyncEffect(async () => await thunkCreator(), [thunkCreator, ...(deps ?? [])]);
};
